import { useTranslation } from 'react-i18next'
import {
  getSidebarBullets,
  getSidebarTitle,
} from '../../features/appConfigSlice'
import { useAppSelector } from '../../hooks/useAppSelector'
import SidebarBullets from '../SidebarBullets/SidebarBullets'
import { companyLabel } from './SidebarTextBlock.css'

const SidebarTextBlock = () => {
  const sidebarTitle = useAppSelector(getSidebarTitle)
  const { t } = useTranslation('jumbotron')
  const sidebarBullets = useAppSelector(getSidebarBullets)
  const isEmptySidebarBullets = sidebarBullets && sidebarBullets.length === 0

  return (
    <>
      {!isEmptySidebarBullets && (
        <>
          <h1>{sidebarTitle || t('title')}</h1>
          <SidebarBullets />
        </>
      )}
      <span className={companyLabel}>{t('company_label')}</span>
    </>
  )
}

export default SidebarTextBlock
